module.exports = __webpack_public_path__ + "img/2639.45b116d1.svg";